import { getStrings, type Lang } from '../i18n'

export function RangeBar({
  low,
  high,
  marker,
  lang = 'en',
}: {
  low: number
  high: number
  marker: number
  lang?: Lang
}) {
  const t = getStrings(lang)
  const span = Math.max(high - low, 1)
  const clamped = Math.min(Math.max(marker, low), high)
  const pct = ((clamped - low) / span) * 100
  return (
    <div
      className="range-bar"
      role="img"
      aria-label={t.rangeBar(low, high, marker)}
    >
      <div className="range-bar-track" />
      <div className="range-bar-tick" style={{ left: 0 }} />
      <div className="range-bar-tick" style={{ left: '100%' }} />
      <div className="range-bar-dot" style={{ left: `${pct}%` }} />
    </div>
  )
}
